import { decode } from 'jsonwebtoken';

import {} from 'lodash';
import getJwt from 'core/axios/getJwt';

const getPublicCourseCatalogURL = () => {
  const token = getJwt();
  const jwtPayload = {
    ...((token && decode(token)) || {}),
  };
  const districtSlug = jwtPayload?.district_slug ?? 'my-district';
  return `/course-catalog/${districtSlug}`;
};

export default getPublicCourseCatalogURL;
